// The 6-digit one-time-code field, shared by both MFA screens.
//
// `autoComplete="one-time-code"` is what lets iOS/Android offer the code from
// the SMS or the authenticator, and `inputMode="numeric"` gets the number pad
// on mobile — most vendors will do this on a phone.
//
// Non-digits are stripped rather than rejected, because a vendor pasting from
// an authenticator app often brings a space with it.
export function CodeInput({
  value,
  onChange,
  disabled,
  autoFocus,
}: {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean | undefined;
  autoFocus?: boolean | undefined;
}) {
  return (
    <input
      className="w-full rounded-lg border border-slate-300 px-3 py-2 text-center text-lg tracking-[0.3em] outline-none focus:border-brand-primary"
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={6}
      value={value}
      disabled={disabled}
      autoFocus={autoFocus}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      placeholder="123456"
      aria-label="6-digit code"
    />
  );
}
